import type { MessageDescriptor } from "@lingui/core";

import { msg } from "@lingui/core/macro";

import { ReportType, UploadStatus } from "../../../api";

export const reportTypes: Record<ReportType, MessageDescriptor> = {
  [ReportType.medical_record]: msg`Medical record`,
  [ReportType.hospitalization_record]: msg`Hospitalization record`,
  [ReportType.ecg]: msg`ECG`,
  [ReportType.labs]: msg`Labs`,
  [ReportType.single_exam]: msg`Single exam`,
};

export const uploadStatuses: Record<UploadStatus, MessageDescriptor> = {
  [UploadStatus.pending]: msg`Pending`,
  [UploadStatus.success]: msg`Success`,
  [UploadStatus.failed]: msg`Failed`,
  [UploadStatus.quarantined]: msg`Quarantined`,
  [UploadStatus.expired]: msg`Expired`,
};
